<template>
  <div>
    <van-popup
      style="background: initial"
      v-model="$store.state.AppDownload"
      z-index="2600"
      :close-on-click-overlay="false"
    >
      <div
        v-if="this.isIos && $store.state.config.ios_add_home"
        class="ui-overlay wg-fixed-no-desktop"
      >
        <div
          class="ui-popup ui-popup--center safe-area-top safe-area-bottom _mask_1o1cn_92"
        >
          <div class="_saveShortcut_1o1cn_30 _isBottomGuideModal_1o1cn_72">
            <div class="_content_1o1cn_39">
              <div class="_closeBtn_1o1cn_57" @click="cancelDownload">
                <img
                  class="lobby-image lobby-image lobby-image--skeleton"
                  src="data://image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
                  alt="."
                />
              </div>
              <div class="_text_1o1cn_39">
                <div class="_tips_1o1cn_39">
                  <span class="_index_1o1cn_45">1</span
                  ><span> Clicar</span> "<span>
                    <i
                      class="lobby-image lobby-image"
                      style="
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <svg
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        class=""
                        viewBox="0 0 37.571 51.36"
                      >
                        <path
                          d="M6.414,51.36A6.379,6.379,0,0,1,.033,45.709,6.046,6.046,0,0,1,0,45.067V20.791a6.058,6.058,0,0,1,.033-.643A6.379,6.379,0,0,1,6.414,14.5h6.414v3.6H6.414a2.727,2.727,0,0,0-2.749,2.7V45.067a2.726,2.726,0,0,0,2.749,2.7H31.156a2.726,2.726,0,0,0,2.749-2.7V20.791a2.727,2.727,0,0,0-2.749-2.7H24.741V14.5h6.415a6.363,6.363,0,0,1,6.414,6.294V45.067a6.363,6.363,0,0,1-6.414,6.294ZM17.628,31.085V4.973L11.7,9.6A1.5,1.5,0,1,1,9.852,7.232L19.129,0,28.4,7.232A1.5,1.5,0,0,1,26.56,9.6L20.628,4.972V31.085a1.5,1.5,0,1,1-3,0Z"
                        ></path>
                      </svg>
                    </i> </span
                  >" <span> Abrir barra de menu</span>
                </div>
                <div class="_tips_1o1cn_39">
                  <span class="_index_1o1cn_45">2</span
                  ><span> Selecionar</span> "
                  <i
                    class="lobby-image lobby-image"
                    style="
                      display: inline-flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <svg
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      class=""
                      viewBox="0 0 34 34"
                    >
                      <path
                        id="f8cfedabfb829863fece3eb47686fa30-comm_icon_zpm_ios"
                        d="M6.8,34A6.8,6.8,0,0,1,0,27.2V6.8A6.8,6.8,0,0,1,6.8,0H27.2A6.8,6.8,0,0,1,34,6.8V27.2A6.8,6.8,0,0,1,27.2,34ZM2.55,6.8V27.2A4.255,4.255,0,0,0,6.8,31.45H27.2A4.256,4.256,0,0,0,31.451,27.2V6.8A4.256,4.256,0,0,0,27.2,2.55H6.8A4.255,4.255,0,0,0,2.55,6.8Zm13.174,17V18.276H10.2a1.275,1.275,0,0,1,0-2.55h5.525V10.2a1.275,1.275,0,1,1,2.55,0v5.525H23.8a1.275,1.275,0,1,1,0,2.55H18.274V23.8a1.275,1.275,0,1,1-2.55,0Z"
                        transform="translate(0)"
                      ></path>
                    </svg> </i
                  >" <span> Adicionar à tela inicial</span>
                </div>
              </div>
              <div class="_arrow_1o1cn_62">
                <i
                  class="lobby-image lobby-image"
                  style="
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <svg
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    class=""
                    viewBox="0 0 64.32 129.568"
                  >
                    <path
                      id="fe03bab6c4447e458ae6a83f6f60ad35-箭头"
                      d="M21.972,83.169H6.214a2.063,2.063,0,0,0-1.767,3.079l10.223,15.809,16.168,25,3.706,5.732a2.073,2.073,0,0,0,3.534,0L48.3,116.984l16.168-25,3.706-5.732a2.063,2.063,0,0,0-1.767-3.079H50.65l1.973,1.5q-.713-3.927-1.426-7.854-1.713-9.43-3.424-18.861Q45.7,46.545,43.631,35.135q-1.79-9.865-3.582-19.73l-1.18-6.5c-.186-1.022-.31-2.08-.561-3.087-.011-.044-.016-.091-.025-.135-.354-1.953-3.591-1.954-3.946,0l-1.426,7.854L29.488,32.4q-2.072,11.41-4.143,22.821-1.79,9.864-3.582,19.729c-.58,3.2-1.2,6.388-1.741,9.591-.008.045-.016.09-.025.134a2.1,2.1,0,0,0,1.429,2.518,2.064,2.064,0,0,0,2.518-1.429q.713-3.928,1.426-7.854,1.712-9.43,3.424-18.861,2.071-11.411,4.142-22.821,1.79-9.865,3.582-19.73L37.7,9.99c.186-1.021.441-2.056.56-3.087.005-.045.016-.091.025-.135H34.338q.712,3.927,1.426,7.854,1.712,9.431,3.424,18.862Q41.259,44.893,43.33,56.3q1.79,9.865,3.582,19.729l1.181,6.5c.185,1.021.309,2.08.56,3.087.011.044.016.09.025.135a2.06,2.06,0,0,0,1.973,1.5H66.409l-1.767-3.079L54.419,99.992,38.251,125l-3.706,5.732h3.534L27.855,114.919l-16.168-25L7.98,84.182,6.214,87.261H21.972c2.634,0,2.638-4.093,0-4.093"
                      transform="translate(-4.151 -4.215)"
                    ></path>
                  </svg>
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="ant-modal-content"
        v-else
        style="width: 7rem; border: 0.01rem solid"
      >
        <div class="ant-modal-body">
          <div
            class="ant-modal-body-conter"
            style="
              padding: 0.2rem;
              display: flex;
              gap: 0.2rem;
              align-items: center;
              justify-content: center;
            "
          >
            <img :src="$store.state.config.home_ico" alt="" />
            <span
              class="azs6RKGF2DadE09dhZqO"
              style="width: 4.16rem; font-size: 0.3rem"
            >
              {{ $t('_home._BaixeeuseoAPP') }}<br />
              <span v-if="$store.state.config.download_give[1] != '0,00'">
                {{ $t('popup._parareceber') }}
                {{ $store.state.config.currency }}
                {{ $store.state.config.download_give[1] }} e<br />
              </span>
              {{ $t('_home._aproveitarmaisdescontos') }}
            </span>
          </div>
          <div v-if="$store.state.config.ui_version == '3.7'">
            <div class="_iosBtn_1wpxt_117" style="width: 48%;float: left;margin-right: 4%;">
              App rápido(6.1M)
            </div>
            <div class="_iosBtn_1wpxt_117" style="width: 48%;float: left;background-color: var(--theme-primary-color);color: #fff;">
              App original(77.3M)
            </div>
          </div>
          <div class="_iosBtn_1wpxt_117" @click="myDownload()" v-else>
            {{ $t('_home._BaixeoAPP') }}
            <div
              v-if="$store.state.config.download_give[1] != '0,00'"
              class="tool-tips-box"
            >
              <span
                class="zr8gSibXFpfAbJRSuBde"
                :style="{
                  color:
                    $store.state.config.ui_version == '3.7' ? '#fff' : '#fff'
                }"
              >
                {{ $t('_VIP._Bônus')
                }}{{ $store.state.config.download_give[1] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="QzRd3YqTnYxG8Latq8fW" @click="cancelDownload">
        <img
          class="closeIcon"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
          alt=""
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { changeLoginPassword } from '@/apis/modules/login.js';
import { Toast } from 'vant';
export default {
  props: {
    changePassword: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      active: 1,
      captcha: '',
      isTetUsername: '',
      isTetUsernameValue: '',
      isIos: navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      projectName: this.$store.state.config.project_name.split('.')[0],
      fonData: {
        new_password: '',
        new_password_confirm: '',
        new_passwordTi: {
          type: 'password'
        },
        new_password_confirmTi: {
          type: 'password'
        }
      }
    };
  },
  components: {},
  created() {
    let _this = this;
    this.$initGeetest4(
      {
        captchaId: this.$store.state.config.captcha_config.id,
        product: 'bind',
        language: _this.$store.state.config.captcha_config.language
      },
      function (captcha) {
        _this.captcha = captcha;
        captcha
          .onReady(function () {})
          .onSuccess(function () {
            var result = captcha.getValidate();
            result.captcha_id = _this.$store.state.config.captcha_config.id;
            _this.active = 2;
            // _this.checkComplete(_this.conTnetfrom)
          })
          .onError(function () {});
        // let co=captcha.showCaptcha();
      }
    );
  },
  methods: {
    cancelDownload() {
      this.$store.commit('publicFun', ['AppDownload', false]);
      if (this.$store.state.isRefreshLoading) {
        setTimeout(() => {
          let inviteTime = localStorage.getItem('inviteTime');
          if (inviteTime) {
            if (inviteTime > new Date().getTime()) {
              this.$store.commit('publicFun', ['isCancelDisplay', false]);
            } else {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
            }
          } else {
            this.$store.commit('publicFun', ['isCancelDisplay', true]);
          }
          if (!this.$store.state.popList.length)
            this.$store.commit('publicFun', ['isCancelDisplay', false]);
          if (
            !this.$store.state.isCancelDisplay &&
            this.$store.state.first_recharge.status == 'show'
          ) {
            let isRechargeGiftTime = localStorage.getItem('isRechargeGiftTime');
            let isRechargeGift = localStorage.getItem('isRechargeGift');
            if (!isRechargeGift && !isRechargeGiftTime)
              this.$store.commit('publicFun', ['isRechargeGift', true]);
          }
        }, 500);
      }
    },
    // 手动触发安装函数
    triggerPWAInstall() {
      let deferredPrompt = this.$store.state.deferredPrompt;
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted install');
        } else {
          console.log('User dismissed install');
        }
        deferredPrompt = null;
      });
    },
    myDownload() {
      let uid = this.$store.state.userInfo.id || 0;
      let type = this.isIos ? 1 : 0;
      // 跳转推广落地页
      if (this.$store.state.config.dl_promote_page) {
        let sid =
          window.localStorage.getItem('inviteID') ||
          window.document.documentElement.getAttribute('data-inviteId');
        sid = sid || 'u';
        window.open('/apis/download/p/' + sid + '/' + uid);
      } else if(this.$store.state.config.install_pwa && this.$store.state.deferredPrompt) {
        this.triggerPWAInstall();// 支持PWA时，触发安装
      } else {
        window.open('/apis/download/' + type + '/0/' + uid);
      }
    },
    subForm() {
      if (this.active == 1) {
        if (this.isTetUsername) {
          this.isTetUsernameValue = false;
          this.captcha.showCaptcha();
        } else {
          this.isTetUsernameValue = true;
        }
      } else if (this.active == 2) {
        changeLoginPassword({
          ...this.fonData
        }).then(({ res, data, msg }) => {
          Toast.fail({
            message: this.myLineBreaks(msg),
            duration: 1000
          });
        });
      }
    },
    onInput(e) {
      this.isTetUsername = e;
    },
    showHide(e) {
      this.fonData[e].type =
        this.fonData[e].type == 'password' ? 'text' : 'password';
    }
  }
};
</script>
<style scoped>
.wg-fixed-no-desktop {
  max-width: calc(100vw - 0.32rem);

  margin: 0 auto;
  left: auto !important;
}
._saveShortcut_1o1cn_30._isBottomGuideModal_1o1cn_72 {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.ui-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-height: calc(100vh);
  height: 50vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
._mask_1o1cn_92 {
  height: 100%;
  width: 100%;
}
.ui-popup--center {
  position: relative;
  left: 0;
  right: 0;
  width: fit-content;
  max-width: calc(100vw - 0.32rem);
  margin: 0 auto;
}
.ui-popup {
  position: absolute;
  bottom: 3px;
  max-height: 100%;
  box-sizing: border-box;
  transform-origin: center center;
  -webkit-overflow-scrolling: touch;
}
._saveShortcut_1o1cn_30 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  color: #fff;
}
._saveShortcut_1o1cn_30._isBottomGuideModal_1o1cn_72 ._closeBtn_1o1cn_57 {
  display: flex;
  justify-content: flex-end;
  margin-right: 1rem;
}
._saveShortcut_1o1cn_30 ._content_1o1cn_39 ._closeBtn_1o1cn_57 {
  display: flex;
  justify-content: center;
  margin-top: 0.8rem;
}
._closeBtn_1o1cn_57 img {
  width: 0.64rem;
  height: 0.64rem;
  transform: translateX(2.3rem);
}

._saveShortcut_1o1cn_30._isBottomGuideModal_1o1cn_72 ._text_1o1cn_39 {
  margin-top: 0.56rem;
  width: calc(100vw - 0.32rem);
  transform: translateX(calc(-50vw + 0.16rem));
}
._saveShortcut_1o1cn_30 ._content_1o1cn_39 ._text_1o1cn_39 ._tips_1o1cn_39 {
  display: flex;
  justify-content: center;
  font-size: 0.35rem;
  line-height: 0.4rem;
}
._saveShortcut_1o1cn_30
  ._content_1o1cn_39
  ._text_1o1cn_39
  ._tips_1o1cn_39
  ._index_1o1cn_45 {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
  color: #000;
  text-align: center;
  background-color: #fff;
  border-radius: 50%;
}
._saveShortcut_1o1cn_30
  ._content_1o1cn_39
  ._text_1o1cn_39
  ._tips_1o1cn_39:nth-of-type(2) {
  margin-top: 1rem;
}
._saveShortcut_1o1cn_30._isBottomGuideModal_1o1cn_72 ._arrow_1o1cn_62 {
  display: flex;
  justify-content: center;
  margin-top: 0.4rem;
  font-size: 1rem;
}
.tool-tips-box {
  font-size: 0.18rem;
  height: 0.26rem;
  line-height: 0.26rem;
  padding: 0px 0.07rem;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0.2rem, -80%);
  border-radius: 0.13rem 0.13rem 0.13rem 0;
  background-color: var(--theme-secondary-color-error);
}
.tool-tips-box:after {
  content: '';
  position: absolute;
  left: 0;
  border-bottom: 0.07rem solid transparent;
  border-left: 0.07rem solid var(--theme-secondary-color-error);
  border-right: 0.07rem solid transparent;
  height: 0px;
  width: 0px;
  bottom: -0.06rem;
}

._iosBtn_1wpxt_117 {
  color: var(--theme-primary-color);
  text-align: center;
  border: 0.01rem solid var(--theme-primary-color);
  width: 100%;
  height: 0.6rem;
  padding: 0 0.15rem;
  font-size: 0.2rem;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.1rem;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 0.1rem;
  border-radius: 0.14rem;
}
.ant-modal-content {
  background-color: var(--theme-main-bg-color);
  border: thin solid;
  border-color: var(--theme-color-line);
  border-radius: 0.2rem;
  max-height: calc(100vh - 0.1rem);
  max-height: calc(var(--vh, 1vh) * 100 - 0.1rem);
  overflow: auto;
  position: static;
}
.ant-modal-body {
  padding: 0.3rem 0.2rem 0.2rem;
}
.ant-modal-body-conter {
  display: flex;
  box-sizing: border-box;
  align-items: center;
}

.ant-modal-body-conter img {
  width: 1.2rem;
}

.ant-modal-body-conter .azs6RKGF2DadE09dhZqO {
  color: var(--theme-text-color-darken);
  font-size: 0.3rem;
  margin-left: 0.2rem;
  text-align: left;
}

.conterList {
  height: 0.7rem;
  width: 100%;
  border-radius: 0.1rem;
}
html .van-button.van-button--primary {
  color: var(--theme-primary-color);
}
.rDu16GVie45q71Bb84aD {
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 0.14rem;
  color: var(--theme-primary-color);
  background: transparent !important;
}
._sGGPqnJR7MVJRNIl6_b {
  font-size: 0.22rem;
  margin-left: 0.08rem;
  overflow: hidden;
}
.steps-conter {
  display: flex;
  align-items: center;
  padding: 0 0.8rem;
  width: 100%;
  padding-bottom: 0.3rem;
  justify-content: space-between;
}

.steps-conter .step {
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 50%;
  font-size: 0.24rem;
  height: 0.6rem;
  line-height: 0.6rem;
  margin: 0;
  display: inline-block;
  width: 0.6rem;
  z-index: 9;
  min-width: 0.6rem;
  min-height: 0.6rem;
  text-align: center;
  max-width: 0.6rem;
  max-height: 0.6rem;
  color: var(--theme-text-color-lighten);
  font-size: 0.24rem;
  position: relative;
}

.ant-form-explain {
  color: var(--theme-secondary-color-error);
  font-size: 0.18rem;
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  line-height: 1.5 !important;
  position: relative;
  padding-left: 0.3rem;
  margin-bottom: 0.2rem;
}

.ant-form-explain::before {
  background-color: var(--theme-secondary-color-error);
  content: '';
  height: 0.18rem;
  margin-right: 0.1rem;
  visibility: visible;
  left: 0;
  top: 50%;
  margin-top: -0.09rem;
  width: 0.18rem;
  display: inline-block;
  position: absolute;
  background-image: url('./../../assets/5e8fdeaf-a95f-4566-adac-d84c9605a176.png');
  background-size: 13.068rem 12.753rem;
  border-radius: 50%;
  background-position: -12.888rem -3.825rem;
}

.steps-conter .step .unmber {
  text-align: center;
}

.steps-conter .active.step {
  background-color: var(--theme-primary-color);
  border: thin solid var(--theme-primary-color);
  color: var(--theme-primary-font-color) !important;
}

.steps-conter .active.step .finish-text {
  color: var(--theme-primary-color) !important;
}

.steps-conter .step .step__line {
  background-color: var(--theme-color-line);
  height: 100%;
  position: absolute;
  top: 50%;
  z-index: 0;
  left: 0.6rem;
  transform: translate(0, -50%);
  height: 0.1rem;
  width: 1.53rem;
}

.steps-conter .step:last-child .step__line {
  width: 0;
}

.steps-conter .step .finish-text {
  position: absolute;
  bottom: -0.5rem;
  white-space: nowrap;
  left: 50%;
  transform: translate(-50%);
  color: var(--theme-text-color-lighten);
  font-size: 0.2rem;
}

/* .finish-text{
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%);
	} */
.ant-modal-content .ant-modal-header {
  background-color: var(--theme-main-bg-color);
  border-bottom: none;
  border-radius: 0.2rem 0.2rem 0 0;
  padding: 0.2rem 0.3rem;
}

.ant-modal-header .ant-modal-title {
  color: var(--theme-text-color-darken);
  font-size: 0.24rem;
  font-weight: revert;
  line-height: 0.34rem;
  text-align: center;
}

.QzRd3YqTnYxG8Latq8fW {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background: none;
  border-radius: 50%;
  bottom: -0.88rem;
  display: -ms-flexbox;
  display: flex;
  height: 0.64rem;
  justify-content: center;
  margin-right: -0.3rem;
  position: absolute;
  right: 50%;
  top: auto;
  width: 0.64rem;
}

.QzRd3YqTnYxG8Latq8fW .closeIcon {
  width: 100%;
  height: 100%;
}
</style>
